/** Defer the history entry so React's effect replay cannot queue a stale Back. */
export function attachSheetHistory(
  history: Pick<History, "state" | "pushState" | "back">,
  events: Pick<Window, "addEventListener" | "removeEventListener">,
  onBack: () => void,
) {
  let pushed = false;
  const timer = setTimeout(() => {
    history.pushState({ ...history.state, anjabomSheet: true }, "");
    pushed = true;
  }, 0);
  const back = () => { pushed = false; onBack(); };
  events.addEventListener("popstate", back);
  return () => {
    clearTimeout(timer);
    events.removeEventListener("popstate", back);
    if (pushed && history.state?.anjabomSheet) history.back();
  };
}
